module.exports = __webpack_public_path__ + "img/sapien.53977b8f.png";